<template lang="pug">
  .d-flex.align-items-center.justify-content-between.align-self-center
    div: .input-group.input-group-sm
      .input-group-prepend: .input-group-text Page size
      select.custom-select(:value="pagination.per_page", @change="setPageSize($event.target.value)")
        option 15
        option 30
        option 50
        option(v-if="pagination.total > 50") 100
        option(v-if="pagination.total > 100") {{ pagination.total }}
    small.p-1
      | Items #[strong {{ pagination.from }}]
      | to #[strong {{ pagination.to }}]
      | of #[strong {{ pagination.total }}]
    .btn-group.btn-group-sm
      button.btn(
        v-if="!isFirstPage",
        @click="setPage(1)") First Page
      button.btn(
        v-if="!isFirstPage",
        @click="setPage(pagination.current_page - 1)") Previous Page
      button.btn(
        v-if="!isLastPage",
        @click="setPage(pagination.current_page + 1)") Next Page
      button.btn(
        v-if="!isLastPage",
        @click="setPage(pagination.last_page)") Last Page
</template>

<script>
export default {
  name: 'SimplePagination',

  props: {
    pagination: { required: true }
  },

  computed: {
    isFirstPage () {
      return this.pagination.current_page === 1
    },

    isLastPage () {
      return this.pagination.current_page === this.pagination.last_page
    }
  },

  methods: {
    setPage (page) {
      this.$emit('setPage', page)
    },

    setPageSize (size) {
      this.$emit('setPageSize', Number.parseInt(size))
    }
  }
}
</script>
